import {Injectable} from '@angular/core';
import {ApiClient} from '../../core/services/api.service';
import {getTimestamp} from "../../helpers";

@Injectable({
    providedIn: 'root',
})

export class FeatureService {

    private apiSegment = 'preventivi';

    constructor(
        private http: ApiClient
    ) {
    }

    all() {

        return this.http.get(`${this.apiSegment}`);

    }

    create(data) {

        return this.http.post(`${this.apiSegment}`, data);

    }

    item(id) {

        return this.http.get(`${this.apiSegment}/${id}`);

    }

    update(id, data) {

        if(data instanceof FormData) {
            data.append('_method', 'PUT');
        } else {
            data = Object.assign({}, data, { '_method': 'PUT' });
        }

        return this.http.post(`${this.apiSegment}/${id}`, data);

    }

    delete(id) {

        return this.http.delete(`${this.apiSegment}/${id}`);

    }

    pdf(id) {

        const timestamp = getTimestamp();
        return this.http.getEndpoint(`${this.apiSegment}/${id}/pdf`, { time: timestamp });

    }

}
